import styled, { css } from 'styled-components';

import { Link } from '@treams/treams-routes';

import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';
import { ButtonSize, IButtonProps } from 'packages/kakapo-ui-kit/types/Button';
import { applyColorFromProps } from 'packages/kakapo-ui-kit/helpers/Theme';

import { fontSizes, colorFromProps, hoverColorFromProps, paddings } from './ButtonShared';

const style = css<IButtonProps>`
	color: ${(props) => colorFromProps(props)};
	background-color: ${(props) =>
		props.disabled ? props.theme.colors.lightBlueDark : applyColorFromProps(props, 'primary')};
	font-size: ${(props) => fontSizes[props.size ?? ButtonSize.Large]};
	line-height: 1.4;
	font-weight: 700;
	font-family: inherit;
	padding: ${(props) => paddings[props.size ?? ButtonSize.Large]};
	box-sizing: border-box;
	text-decoration: none;
	cursor: pointer;
	border-radius: 6px;
	display: ${(props) => (props.fullWidth ? 'block' : 'inline-block')};
	width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
	transition: 150ms background-color ease-out;
	border: 0;
	outline: 0;

	${(props) =>
		props.disabled
			? `cursor: default;`
			: `
		&:hover {
			background-color: ${hoverColorFromProps(props)};
		}
	`}

	@media screen and (max-width: ${Breakpoint.Small}) {
		padding: ${(props) => (props.size === ButtonSize.Small ? '5px 12px' : '8px')};
		white-space: inherit;
	}

	svg {
		margin-right: ${(props) => (props.size === ButtonSize.Small ? '5px' : '10px')};
		vertical-align: middle;
	}
`;

export default styled.button<IButtonProps>`
	display: inline-block;
	line-height: 24.5px;
	${style}
`;

export const PrimaryButtonLink = styled(Link)<IButtonProps>`
	${style}
`;

export const SubmitButton = styled.input<IButtonProps>`
	${style}
	box-sizing: border-box;
`;

export const PrimaryButtonAnchor = styled.a<IButtonProps>`
	${style}
`;

export const PrimaryButtonLabel = styled.label<IButtonProps>`
	${style}
`;
